import React from "react";
import HeroCarousel from "../components/HeroCarousel";
import SEO from "../components/SEO";
import HomeIntro from "../components/HomeIntro";
import HomeHighlights from "../components/HomeHighlights";
import HomeServicesPreview from "../components/HomeServicesPreview";
import HomeProof from "../components/HomeProof";
import HomeCommunity from "../components/HomeCommunity";

const HomePage = () => (
  <>
    <SEO
      title="Kyros Games | Videogame autoprodotti, Store e launcher"
      description="Zombie Crushers, WarFront e Ghost Hunter: videogame Kyros per Windows da scaricare, comprare o seguire in playtest."
      canonical="https://kyrosgames.com/"
      structuredData={{
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "WebPage",
            "@id": "https://kyrosgames.com/#webpage",
            "url": "https://kyrosgames.com/",
            "name": "Kyros Games | Videogame autoprodotti, Store e launcher",
            "inLanguage": "it-IT",
            "isPartOf": { "@id": "https://kyrosgames.com/#website" },
            "breadcrumb": { "@id": "https://kyrosgames.com/#breadcrumb" }
          },
          {
            "@type": "BreadcrumbList",
            "@id": "https://kyrosgames.com/#breadcrumb",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://kyrosgames.com/"
              }
            ]
          }
        ]
      }}
    />
    <HomeIntro />
    <HeroCarousel />
    <HomeHighlights />
    <HomeServicesPreview />
    <HomeProof />
    <HomeCommunity />
  </>
);

export default HomePage;
